export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd032021',
  loginNameProject: 'BIODIGESTOR RENU JACAREZINHO',
  sideNameProject: 'BIO RENU JACAREZINHO',
  exibirGraficoInicial: false,
  iconeInterno: '../static/img/logo_renu_jacarezinho.svg',
  grafico: {
    parametro: 'BiodigestorVazaoAcumulada',
    titulo: 'Gás consumido a partir do dia',
    label: 'Gás consumido (m³)'
  },
  idioma: 'Pt-Br'
}



// WEBPACK FOOTER //
// ./src/config/index.js